module.exports = __webpack_public_path__ + "img/phone-icon.2464bff5.svg";